import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail/advanced_search.svg';
const AdvancedSearchSvg = ({ className }) => React.createElement(IconSvg, { className: className });
export default AdvancedSearchSvg;
